import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectionListChange } from '@angular/material/list';
import * as _ from 'lodash';
import { Client } from 'src/app/domain/client';
import { Contact } from 'src/app/domain/contact';
import { UserService } from 'src/app/services/user.service';


@Component({
    selector: 'app-contact-box',
    templateUrl: './contact-selection-box.html',
    styleUrls: ['./contact-selection-box.scss']
})
export class ContactSelectionBoxDialog implements OnInit {

    searchText: string = '';

    public Contact: Contact = new Contact();
    alreadyAssignedList: Contact[] = [];

    public AvailableContactList: Contact[] = [];

    SelectedContactList: Contact[] = [];


    constructor(
        private userService: UserService,
        public dialogRef: MatDialogRef<ContactSelectionBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        if (data.client) {
            this.Contact = Object.assign({}, data.contact);
        } else {
            this.alreadyAssignedList = data.alreadyAssignedList;
        }
    }

    ngOnInit() {

    }

    searchNewContact() {
        this.userService.getContactList(this.searchText).subscribe(x => {
            this.AvailableContactList = _.differenceBy(x, this.alreadyAssignedList, x => x.Code);
            this.AvailableContactList = _.sortBy(this.AvailableContactList, [
                function (item) { return item.Name; },
            ]);
        });
    }

    setSelectedContacts(event: MatSelectionListChange) {

        if (event.options[0].selected) {
            this.SelectedContactList.push(...event.options.filter(e => e.selected).map(x => x.value));
        } else {
            _.remove(this.SelectedContactList, x => x.Code === event.options[0].value.Code)
        }
    }

    CanAdd() {
        return this.searchText.length >= 1;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.searchText);
    }
}
